// extracted by mini-css-extract-plugin
export default {"container":"App_container__Rt8T2","routesContainer":"App_routesContainer__o89Cg","loaderContainer":"App_loaderContainer__7Zo9Y"};